import {
  GET_USER_PROFILE_ERROR,
  GET_USER_PROFILE_PROGRESS,
  GET_USER_PROFILE_SUCCESS,
  UPDATE_USER_PROFILE_ERROR,
  UPDATE_USER_PROFILE_PROGRESS,
  UPDATE_USER_PROFILE_SUCCESS,
} from "../../../constants/ActionTypes";

const defaultStatus = {
  progressing: false,
  success: false,
  error: false,
  data: [],
};
const initialState = {
  getprofile: { ...defaultStatus },
  updateprofile: { ...defaultStatus },
};
const profileReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_USER_PROFILE_PROGRESS:
      return {
        ...state,
        getprofile: {
          ...defaultStatus,
          ...payload,
          progressing: true,
        },
      };
    case GET_USER_PROFILE_SUCCESS:
      return {
        ...state,
        getprofile: {
          ...defaultStatus,
          ...payload.data,
          success: true,
        },
      };
    case GET_USER_PROFILE_ERROR:
      return {
        ...state,
        getprofile: {
          ...defaultStatus,
          ...payload,
          error: true,
        },
      };

    case UPDATE_USER_PROFILE_PROGRESS:
      return {
        ...state,
        updateprofile: {
          ...defaultStatus,
          ...payload,
          progressing: true,
        },
      };
    case UPDATE_USER_PROFILE_SUCCESS:
      return {
        ...state,
        updateprofile: {
          ...defaultStatus,
          ...payload,
          success: true,
        },
      };
    case UPDATE_USER_PROFILE_ERROR:
      return {
        ...state,
        updateprofile: {
          ...defaultStatus,
          ...payload,
          error: true,
        },
      };
    default:
      return state;
  }
};

export default profileReducer;
